import { SiteHeader } from "@/components/Brand";
import { SiteFooter } from "@/components/SiteFooter";

export const PageShell = ({ title, subtitle, testid, children }) => (
  <div className="flex min-h-screen flex-col bg-[#0B132B]" data-testid={testid}>
    <SiteHeader />
    <main className="flex-1 px-6 py-16">
      <div className="mx-auto max-w-[760px]">
        <h1 className="font-heading text-3xl font-extrabold tracking-tight text-white md:text-4xl">
          {title}
        </h1>
        {subtitle && <p className="mt-4 text-lg leading-relaxed text-[#BFD4E8]">{subtitle}</p>}
        <div className="mt-8 space-y-6 text-[15px] leading-relaxed text-[#BFD4E8]">
          {children}
        </div>
      </div>
    </main>
    <SiteFooter />
  </div>
);

export const Section = ({ heading, children, id }) => (
  <section id={id} className="space-y-3 scroll-mt-28">
    {heading && (
      <h2 className="font-heading text-xl font-bold text-white">{heading}</h2>
    )}
    {children}
  </section>
);

export default PageShell;
